import React, { useEffect, useState } from 'react';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from './CustomHighChart';

const ChartFaultOverLocation = ({ isLoading, series, locations }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    async function fetchData() {
      if (!isLoading) {
        const chart = await chartObjectCreator({
          chart: {
            renderTo: 'chrtContainer',
            type: 'column',
            height: 380,
          },
          xAxis: {
            categories: locations,
            title: {
              text: 'Locations',
            },
            crosshair: true,
          },
          yAxis: [
            {
              // Secondary yAxis
              title: {
                text: 'Total Fault Duration (minutes)',
              },
              opposite: true,
            },
            {
              // Primary yAxis
              title: {
                text: 'Fault Count',
              },
              labels: {
                overflow: 'justify',
              },
            },
          ],
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
              },
            },
          },
          series,
        });
        setData(chart);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default ChartFaultOverLocation;
